import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { Colors } from '../..';
const {
  new_grey,
  plum_paddl,
  white,
  social_behance,
  social_dribbble,
  social_facebook,
  social_instagram,
  social_github,
  social_linkedin,
  social_twitter
} = Colors;
export const iconStylesCommon = {
  colours: {
    backgroundColour: 'transparent',
    logoColour: new_grey,
    backgroundStrokeColour: new_grey
  },
  hoverColours: {
    backgroundColour: plum_paddl,
    logoColour: white,
    backgroundStrokeColour: plum_paddl
  }
};
export const behanceStyles = {
  colours: iconStylesCommon.colours,
  hoverColours: {
    logoColour: white,
    backgroundColour: social_behance,
    backgroundStrokeColour: social_behance
  }
};
export const dribbleStyles = {
  colours: iconStylesCommon.colours,
  hoverColours: {
    logoColour: white,
    backgroundColour: social_dribbble,
    backgroundStrokeColour: social_dribbble
  }
};
export const facebookStyles = {
  colours: iconStylesCommon.colours,
  hoverColours: {
    logoColour: white,
    backgroundColour: social_facebook,
    backgroundStrokeColour: social_facebook
  }
};
export const instagramStyles = {
  colours: iconStylesCommon.colours,
  hoverColours: {
    logoColour: white,
    backgroundColour: social_instagram,
    backgroundStrokeColour: social_instagram
  }
};
export const githubStyles = {
  colours: iconStylesCommon.colours,
  hoverColours: {
    logoColour: white,
    backgroundColour: social_github,
    backgroundStrokeColour: social_github
  }
};
export const linkedinStyles = {
  colours: iconStylesCommon.colours,
  hoverColours: {
    logoColour: white,
    backgroundColour: social_linkedin,
    backgroundStrokeColour: social_linkedin
  }
};
export const twitterStyles = {
  colours: iconStylesCommon.colours,
  hoverColours: {
    logoColour: white,
    backgroundColour: social_twitter,
    backgroundStrokeColour: social_twitter
  }
};
export const ProfileLinksList = /*#__PURE__*/_styled("ul", process.env.NODE_ENV === "production" ? {
  target: "e1en28wb0"
} : {
  target: "e1en28wb0",
  label: "ProfileLinksList"
})(process.env.NODE_ENV === "production" ? {
  name: "1qwtgjr",
  styles: "list-style:none;display:flex;padding:0;li{margin-right:12px;button{border:none;}svg{width:30px;height:30px;}}"
} : {
  name: "1qwtgjr",
  styles: "list-style:none;display:flex;padding:0;li{margin-right:12px;button{border:none;}svg{width:30px;height:30px;}}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});